import {useState,useMemo,useEffect,useCallback} from "react";
import {useSnackbar} from '../SnackbarContext.js';
import {consoleLog,dateFns_to_db} from '../../../core/utilities/Utilities.js';
import {generateReport} from '../../integration/Api.js';
import COMPONENT_MAP from '../Repository/Components.js';
const file='ReportDetailAccountHoursPeriod.js';

const ReportDetailAccountHoursPeriod=({userData,application})=>{
    const [loading,setLoading]=useState(false);
    const [rows,setRows]=useState([]);
    const [dateFilter,setDateFilter]=useState({
        start:new Date(),
        end:new Date()
    });
    const {showSnackbar}=useSnackbar();
    const lang=application?.globalData?.lang;

    const processGenerateReport=useCallback(()=>{
        setLoading(true);
        const reportParams=["start_date="+dateFns_to_db(dateFilter.start)+" 00:00:00","end_date="+dateFns_to_db(dateFilter.end)+" 00:00:00",'_lang='+lang];
        consoleLog({file:file,context:'processGenerateReport',arg_name:'reportParams',arg_value:reportParams});
        generateReport({reportType:'accounts_hours_period',reportParams:reportParams})
        .then((data)=>{
            consoleLog({file:file,context:'processGenerateReport - generate_report',arg_name:'data',arg_value:data});
            if('error' in data){
                showSnackbar(data.error,'error');
            }
            else if(data.length>0){
                setRows(old=>data);
            }
            else{
                setRows(old=>[]);
            }
            setLoading(false);
        });
    },[dateFilter,lang,showSnackbar]);

    useEffect(()=>{
        processGenerateReport();
    },[dateFilter,processGenerateReport]);

    const renderFilterDate=useCallback(()=>{
        const Component=COMPONENT_MAP['FilterDate'];
        return Component?(
            <Component
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                application={application}
            />
        ):null;
    },[dateFilter,application]);

    const handleClickEvent=useCallback((args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'click_event',arg_value:args});
        switch(args?.action){
            case "generateReport":
                setRows(old=>[]);
                processGenerateReport();
                break;
            default:
                break;
        }
    },[processGenerateReport]);

    const renderList=useMemo(()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={rows}
                list_name={'report_account_period_hours'}
                loading={loading}
                height={window.innerHeight-170}
                file={file}
                application={application}
                initialState={{}}
                entityRules={{noData:'true'}}
                userData={userData}
                actions={{}}
                handleClickEvent={handleClickEvent}
                filterComponent={renderFilterDate()}
                noRefresh={true}
            />
        ):null; 
    },[rows,loading,application,userData,handleClickEvent,renderFilterDate])

    return(renderList);
}

export default ReportDetailAccountHoursPeriod;
